export enum AccountUrls {
  loggedUserUrl = 'https://portal.office.com/account/#personalinfo',
  loggedUserTitle = 'Account Settings',
  switchApiUrl = 'https://switch-sandbox.xpoapi.com/users/',
  pictureUrl = '/picture?size=medium',
}
